// extracted by mini-css-extract-plugin
module.exports = {"itemImage":"PeoplePage_itemImage__aYAx_"};